export default "__VITE_ASSET__DryZz9qo__"